<div class="legal-page">

  <!-- Hero -->
  <div class="legal-hero">
    <div class="legal-hero__bg"></div>
    <div class="legal-hero__content">
      <a routerLink="/" class="legal-hero__back">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <path d="M19 12H5M5 12l7-7M5 12l7 7"/>
        </svg>
        Retour à l'accueil
      </a>
      <div class="legal-hero__badge">Documents légaux</div>
      <h1 class="legal-hero__title">Mentions légales</h1>
      <p class="legal-hero__subtitle">Informations légales relatives à l'éditeur et au fonctionnement du site Referio.</p>
      <p class="legal-hero__date">Dernière mise à jour : {{ lastUpdate }}</p>
    </div>
  </div>

  <div class="legal-layout">

    <!-- Sidebar sommaire -->
    <aside class="legal-sidebar">
      <div class="legal-sidebar__inner">
        <p class="legal-sidebar__label">Sommaire</p>
        <nav class="legal-sidebar__nav">
          <button
            *ngFor="let section of sections; let i = index"
            class="legal-sidebar__item"
            (click)="scrollTo(section.id)">
            <span class="legal-sidebar__num">{{ (i + 1).toString().padStart(2, '0') }}</span>
            <span class="legal-sidebar__text">{{ section.title }}</span>
          </button>
        </nav>
      </div>
    </aside>

    <!-- Content -->
    <main class="legal-content">
      <section
        *ngFor="let section of sections; let i = index"
        [id]="section.id"
        class="legal-section">
        <div class="legal-section__header">
          <span class="legal-section__num">{{ (i + 1).toString().padStart(2, '0') }}</span>
          <h2 class="legal-section__title">{{ section.title }}</h2>
        </div>
        <div class="legal-section__body">
          <p
            *ngFor="let paragraph of section.content"
            class="legal-section__p"
            [innerHTML]="paragraph">
          </p>
        </div>
      </section>

      <!-- Contact card -->
      <div class="legal-contact-card">
        <div class="legal-contact-card__icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
          </svg>
        </div>
        <div class="legal-contact-card__text">
          <strong>Une question sur ces mentions légales ?</strong>
          <p>Notre équipe juridique est disponible pour vous répondre.</p>
        </div>
        <a routerLink="/contact" class="legal-contact-card__btn">Nous contacter</a>
      </div>
    </main>

  </div>
</div>